module.exports = __webpack_public_path__ + "static/media/nationalcollegeireland.0bf6f2b6.png";